var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
import padding from "@irati/ui/src/global/padding";
import { H4 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import RouterLink from "@irati/ui/src/Link/RouterLink";
export var AdminCard = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  max-width: 360px;\n"], ["\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  max-width: 360px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.border.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.mid;
}, padding.small);
export var FlexGrowH4 = styled(H4)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 2;\n  text-transform: capitalize;\n"], ["\n  flex-grow: 2;\n  text-transform: capitalize;\n"])));
export var FlexGrowPara = styled(Para)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 2;\n"], ["\n  flex-grow: 2;\n"])));
export var MarginLeft = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
export var StyledLink = styled(RouterLink)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &:hover {\n    text-decoration: none; \n  }\n"], ["\n  &:hover {\n    text-decoration: none; \n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
